import React from 'react';

const SearchIcon = () => (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.2939 13.0786H13.3905L13.0703 12.7699C14.191 11.4663 14.8656 9.77387 14.8656 7.93282C14.8656 3.82762 11.538 0.5 7.43282 0.5C3.32762 0.5 0 3.82762 0 7.93282C0 12.038 3.32762 15.3656 7.43282 15.3656C9.27387 15.3656 10.9663 14.691 12.2699 13.5703L12.5786 13.8905V14.7939L18.2962 20.5L20 18.7962L14.2939 13.0786ZM7.43282 13.0786C4.58548 13.0786 2.28702 10.7802 2.28702 7.93282C2.28702 5.08548 4.58548 2.78702 7.43282 2.78702C10.2802 2.78702 12.5786 5.08548 12.5786 7.93282C12.5786 10.7802 10.2802 13.0786 7.43282 13.0786Z"
            fill="white"
        />
    </svg>
);

export { SearchIcon };
